import { useAvailabilityCheckReminderEnabled } from '@web-app/utils/feature-flags/availability-check-reminder-enabled';
import { useProviderCalendarEnabled } from '@web-app/utils/feature-flags/provider-calendar';
import { trpc } from '@web-app/utils/trpc';
import { useRouter } from 'next/router';

/** Shared eligibility, refresh behavior, and calendar destination for reminders. */
export function useAvailabilityReminder(active = true) {
  const calendarEnabled = useProviderCalendarEnabled();
  const reminderEnabled = useAvailabilityCheckReminderEnabled();
  const router = useRouter();
  const enabled = active && calendarEnabled && reminderEnabled;
  const { data, isFetching, isError } = trpc.availability.getReminder.useQuery(
    undefined,
    {
      enabled,
      staleTime: 60_000,
      refetchInterval: 60_000,
      refetchOnMount: 'always',
      refetchOnWindowFocus: 'always',
    },
  );

  return {
    reminder: enabled ? data : null,
    isFetching,
    isError,
    calendarHref:
      router.query['provider-calendar'] === 'true'
        ? '/calendar?provider-calendar=true'
        : '/calendar',
  };
}
